<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.regional.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoRegionais" }'
    )
    .detalhes-regional
        h3.detalhes-regional__titulo {{ $t('mensagens.regional.labels.dadosCadastrais') }}
        .detalhes-regional__card
            Resume(resumeId='detalhes-regional', :resume='nome')
        h3.detalhes-regional__titulo {{ $t('mensagens.regional.labels.dadosVinculados') }}
        .detalhes-regional__card
            ResumeList(
                resumeId='detalhes-regional-regionais',
                :label='$t("mensagens.regional.labels.gerentesRegionais")',
                :resume='idsGerentesRegionais'
            )
        .detalhes-regional__card
            ResumeList(
                resumeId='detalhes-regional-comerciais',
                :label='$t("mensagens.regional.labels.gerentesComerciais")',
                :resume='idsGerentesComerciais'
            )
        .detalhes-regional__card
            ResumeList(
                resumeId='detalhes-regional-territoriais',
                :label='$t("mensagens.regional.labels.gerentesTerritoriais")',
                :resume='idsGerentesTerritoriais'
            )
        .footer
            .footer__btn.voltar(@click='irParaRegionais')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
</template>
<script>
import services from '@/services/ContratoOriginacaoService';
import EventBus from '@/utils/eventBus';

export default {
    name: 'DetalhesRegional',
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        Resume: () =>
            import('@/components/contratosOriginacao/formulario/Resume'),
        ResumeList: () =>
            import('@/components/contratosOriginacao/formulario/ResumeList')
    },
    props: {
        resume: {
            type: [Array, Object],
            default: () => []
        }
    },
    data() {
        return {
            nome: [],
            idsGerentesRegionais: [],
            idsGerentesTerritoriais: [],
            idsGerentesComerciais: [],
            gerentesRegionais: [],
            gerentesTerritoriais: [],
            gerentesComerciais: []
        };
    },
    computed: {
        resumeList() {
            const keysValids = [
                'nome',
                'idsGerentesComerciais',
                'idsGerentesTerritoriais',
                'idsGerentesRegionais'
            ];
            const keys = Object.keys(this.dados);
            const keyMap = keys.map(key => ({
                key,
                label: this.$t(`mensagens.regional.keys.${key}`),
                value: this.resume[key]
            }));
            const resume = keyMap.filter(
                item => keysValids.includes(item.key) && item.value
            );

            return resume;
        }
    },
    mounted() {
        this.carregarListasGerentes();
    },
    methods: {
        async carregarListasGerentes() {
            this.loadingScreen(true);
            if (this.resume?.idsGerentesTerritoriais?.length > 0) {
                await this.buscarGerentesTerritoriais();
            }
            if (this.resume?.idsGerentesComerciais?.length > 0) {
                await this.buscarGerentesComerciais();
            }
            if (this.resume?.idsGerentesRegionais?.length > 0) {
                await this.buscarGerentesRegionais();
            }
            this.montarDados();
            this.loadingScreen(false);
        },
        montarDados() {
            const gerente = { nome: this.resume.nome };

            this.nome = [
                {
                    key: 'nome',
                    label: this.$t('mensagens.regional.keys.nome'),
                    value: gerente.nome
                }
            ];
            if (this.resume?.idsGerentesTerritoriais?.length > 0) {
                const idsGerentesTerritoriais =
                    this.gerentesTerritoriais.filter(gerente =>
                        this.resume.idsGerentesTerritoriais.includes(gerente.id)
                    );
                this.idsGerentesTerritoriais = idsGerentesTerritoriais.map(
                    gerente => ({
                        id: gerente.id,
                        value: gerente.nome
                    })
                );
            }
            if (this.resume?.idsGerentesComerciais?.length > 0) {
                const idsGerentesComerciais = this.gerentesComerciais.filter(
                    gerente =>
                        this.resume.idsGerentesComerciais.includes(gerente.id)
                );
                this.idsGerentesComerciais = idsGerentesComerciais.map(
                    gerente => ({
                        id: gerente.id,
                        value: gerente.nome
                    })
                );
            }
            if (this.resume?.idsGerentesRegionais?.length > 0) {
                const idsGerentesRegionais = this.gerentesRegionais.filter(
                    gerente =>
                        this.resume.idsGerentesRegionais.includes(gerente.id)
                );
                this.idsGerentesRegionais = idsGerentesRegionais.map(
                    gerente => ({
                        id: gerente.id,
                        value: gerente.nome
                    })
                );
            }
        },
        buscarGerentesRegionais() {
            return services.buscarGerentesRegionais().then(({ data }) => {
                if (data.length > 0) {
                    this.gerentesRegionais = data;
                }
            });
        },
        buscarGerentesTerritoriais() {
            return services.buscarGerentesTerritoriais().then(({ data }) => {
                if (data.length > 0) {
                    this.gerentesTerritoriais = data;
                }
            });
        },
        buscarGerentesComerciais() {
            return services.buscarGerentesComerciais().then(({ data }) => {
                if (data.length > 0) {
                    this.gerentesComerciais = data;
                }
            });
        },
        irParaRegionais() {
            this.$router.push({ name: 'ConfiguracaoRegionais' });
        },
        loadingScreen(isLoading) {
            const options = {
                mostrarLoading: isLoading,
                lockMessage: this.$t('mensagens.sistema.carregando')
            };
            EventBus.$emit('emit-componente-carregando', options);
        }
    }
};
</script>

<style lang="scss" scoped>
.detalhes-regional {
    margin: 20px;
    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }
    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();
        & + & {
            margin-top: 20px;
        }
    }
}

.footer {
    display: flex;
    justify-content: flex-end !important;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}
.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
